define('models/OfferedProductCollection',['underscore','app','ApiRequest','ObjectCollection','LocalStorage','models/OfferedProductModel'],function (_,app,ApiRequest,ObjectCollection,LocalStorage,OfferedProductModel) {
    //
    // Collection OfferedProduct
    //

    // todo static var

    function AjaxFail(response, status, data) {
        //
        switch(status){
            case 'abort': break;
            default:
                app.alert();
        }
    }

    var OfferedProductCollectionPrototype = {

        name:'OfferedProductCollection',
        model:OfferedProductModel,

        initialize:function(){
            // ObjectCollection constructor heritage
            var collection = this;
            ObjectCollection.prototype.initialize.apply(collection,arguments);
            //
            collection.on('change',collection.updateQuantityFree);
            //
        },
        attachCart:function(cart){
            var collection = this;
            collection.cart = cart;
            cart.on('change:consumables_qty removeProduct addProduct',collection.onChangeCartQuantity,collection);
            collection.onChangeCartQuantity();
        },
        onChangeCartQuantity:function(e,b,c){
            var collection = this;
            collection.each(function(model){
                model.setup();
            });
            collection.updateQuantityFree();
        },
        updateQuantityFree:function(){
            this.each(function(model){
               model.set('free',model.getQuantityFree());
            });
        },
        getModelBySlug:function(slug){
            return this.findWhere({slug:slug})
        },
        getQuantityBySlug:function(slug){
            var offeredProductModel = this.getModelBySlug(slug);
            if(offeredProductModel){
                return offeredProductModel.getQuantity();
            }
            return 0;
        },
        isPresetValues:function(){
            // renvoie true si toutes les valeurs sont en accord avec le preset
            var valid = true;
            this.each(function(model){
                valid &= model.getQuantity() == model.getPreset();
            });
            return valid;
        },
        resetPreset:function(){
            // reset all quantity to preset value
            this.each(function(model){model.resetPreset()})
        },
        cancelRequest:function(){
            var jqxhr = this.jqxhr;
            if(jqxhr){
                jqxhr.canceled = true;
            }
        },
        requestPreset:function(){
            var collection = this,
                cart = this.cart,
                jqxhr;
            // update remote value as preset
            collection.cancelRequest();
            jqxhr = collection.jqxhr = ApiRequest('CartConsumableReset', null, {id_cart: cart.id})
            .done(function (data) {
                if(jqxhr && !!jqxhr.canceled) return
                cart.set(data);
                cart.trigger('offeredProductOptionsUpdate', cart);
            })
            .fail(AjaxFail)
        },
        requestSet:function(){
            var collection = this,
                cart = collection.cart,
                quantities = {},
                jqxhr;
            quantities['extra'] = [];
            collection.each(function (model) {
                var suffix = model.id.replace('_','');
                if (model.get('fix') == true){
                    quantities['nbr'+suffix] = model.getQuantity();
                }else
                {
                    quantities['extra'].push(
                        {
                            id_product:model.get('id_product'),
                            qty:model.getQuantity(),
                        }
                    )
                }

            });
            collection.cancelRequest();
            jqxhr = collection.jqxhr = collection.pipeAppHttpHeaders(ApiRequest('CartConsumableOptions', quantities, {id_cart: cart.id}))
            .done(function (data) {
                if(jqxhr && !!jqxhr.canceled) return
                if (!data.total_price_ttc_consumables) {
                    cart.unset('total_price_ttc_consumables');
                }
                cart.set(data);
                cart.trigger('offeredProductOptionsUpdate', data);
            })
            .fail(AjaxFail)

        }
    };

    var OfferedProductCollection = ObjectCollection.extend(OfferedProductCollectionPrototype);

    return OfferedProductCollection;
});
